module.exports = __webpack_public_path__ + "img/thumb_image8.7eda15a4.jpg";